<script setup lang="ts">
import { NavigationFailure } from 'vue-router';
import { useRoute, router } from '@hfc/ui-core';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { UUID } from '@hfc/common/src/types/UUID';
import { ChallengeType } from '@/application/shared/domain/ChallengeQuestionSettings';
import ChallengeQuestions from '@/shared/infrastructure/components/ChallengeQuestions.vue';

const route = useRoute();

const applicationType = route.params.applicationType as string;
const uuid = route.params.uuid as UUID;

const pushRedirect = (): Promise<NavigationFailure | void | undefined> => {
  return router.push({ name: 'UserFeedback', params: { applicationType, uuid } });
};

const getApplicationType = (applicationType: string): APPLICATION_TYPES => {
  const foundType = Object.values(APPLICATION_TYPES).find(type => type === applicationType);
  if (!foundType) {
    throw new Error(`Invalid application type: ${applicationType}`);
  }

  return foundType;
};

</script>
<template>
  <div class="py-10">
    <h1 class="text-center">Send Us Your Feedback or Request Support</h1>
  </div>
  <ChallengeQuestions subtitle="First, confirm your identity." :application-type="getApplicationType(applicationType)" :local-config="false" :challenge-type="ChallengeType.FEEDBACK" :uuid="uuid" @challenge-success="pushRedirect" button-text="Send" />
</template>
